import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_payment_channel_event_RowClass,
  bl_pgw_payment_channel_event_RowInterface
} from '../../dbschema';

export class PaymentChannelEventContainerModel extends BaseContainerModel {
  bl_pgw_payment_channel_event: bl_pgw_payment_channel_event_RowInterface = new bl_pgw_payment_channel_event_RowClass();
}
